module.exports = __webpack_public_path__ + "static-v-shop/1786468182979/img/logo_maestro.0e3ebe42.png";